var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://ct.capterra.com/capterra_tracker.gif?vid=2175762&vkey=0d82c43c431b2e20dbd25978783d0c39"}})
}
var staticRenderFns = []

export { render, staticRenderFns }